<template>
  <v-app id="inspire">
    <v-navigation-drawer
        fixed
        :clipped="$vuetify.breakpoint.mdAndUp"
        app
        v-model="drawer"
    >
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-layout
              row
              v-if="item.heading"
              align-center
              :key="index"
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading" :href="'/hello'">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
              v-else-if="item.children"
              v-model="item.model"
              :key="'elseIf' + index"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon=""
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                v-for="(child, i) in item.children"
                :key="i"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="'else' + index" :to="item.href">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.text }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
        color="blue darken-3"
        dark
        app
        :clipped-left="$vuetify.breakpoint.mdAndUp"
        fixed
    >
      <v-toolbar-title class="ml-0 pl-1 plus300px">
        <span class="hidden-sm-and-down">Hotel4Box</span>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      </v-toolbar-title>
      <v-text-field
          v-model="searchData"
          flat
          solo-inverted
          append-outer-icon="search"
          label="Search"
          clearable
          @click:append-outer="doSearch"
          @keyup.enter="doSearch"
          @click:clear="doSearchClear"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn icon large @click="handleLogout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <v-container  p-3 fluid grid-list-md>
        <v-layout row wrap>
          <router-view></router-view>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {eventBus} from '@/main';
import {logout} from '@/mixins/logout';

export default {
  name: 'OperatorLayout',
  mixins: [logout],
  data() {
    return {
      drawer: null,
      items: [
        {
          icon: 'keyboard',
          text: 'Orders',
          href: '/operator/orders',
          isActive: false,
        },
        {
          icon: 'history',
          text: 'History',
          href: '/operator/history',
          isActive: false,
        },
        {
          icon: 'settings',
          text: 'QR code',
          href: '/operator/qrcode',
          isActive: false,
        },
      ],
      searchData: '',
    }
  },
  methods: {
    doSearch() {
      eventBus.$emit('do-operator-search', this.searchData);
    },
    doSearchClear() {
      this.searchData = '';
      this.doSearch();
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    }
  },
}
</script>
